import { snake } from 'change-case'
import { HumanErrorMessages } from '../../constants'
import { api } from '../../libs/api'
import pagination from './pagination'

export default {
  namespaced: true,

  modules: {
    pagination: pagination(),
  },

  state: {
    index: [],
    detail: {},
    errors: [],
    // 直近の fetchIndex のエラー（成功時は null）。avoidBlank() で使う。
    lastFetchError: null,
  },
  getters: {
  },
  mutations: {
    errors: (state, errors) => state.errors = errors,
    index: (state, index) => {
      const newIndex = index.map((company) => {
        const newCompany = Object.assign({}, company)
        return newCompany
      })
      state.index = newIndex
    },
    clearDetail: state => state.detail = {},
    detail: (state, detail) => state.detail = detail,
    lastFetchError: (state, error) => state.lastFetchError = error,
  },
  actions: {
    async fetchIndex ({ commit, dispatch }, query) {
      try {
        const requestParameters = Object.keys(query).reduce((acc, key) => {
          acc[snake(key)] = query[key]
          return acc
        }, {})
        const { meta, index } = await api.fetchCorporations(requestParameters)
        commit('pagination/newState', meta)
        commit('index', index)
        commit('lastFetchError', null)
      } catch (e) {
        commit('lastFetchError', e)
        const message = (Array.isArray(e) && e[0] && e[0].message) || HumanErrorMessages.SEARCH_FAILED
        dispatch(
          'common/pushToastError',
          { error: { message } },
          { root: true },
        )
        return Promise.reject(e)
      }
    },
    async fetchDetail ({ commit }, { id }) {
      try {
        const response = await api.fetchCorporation(id)
        commit('detail', response[0])
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/corporation.js